export default __webpack_public_path__ + "static/media/riderdome-logo-icon.1ab9bcb4.png";